<template>
  <div id="ddLogin"> loging ····· </div>
</template>

<script>
import { ddScanLogin } from "@/api/login";
import { timeFix } from "@/utils/util"

export default {
    name: "ddScanLogin",
    created(){
      this.authScanLogin();
    },
    methods: {
      authScanLogin(){
          let code = this.$route.query.code;
          let jsonCode = {"code":code}
          this.$store
            .dispatch("ddScanLogin", jsonCode)
            .then(() => {
              this.$router.push({ path: "/dashboard/analysis" })
              this.$notification.success({
                message: '欢迎',
                description: `${timeFix()}，欢迎回来`,
              });
            })
            .catch(() => {
              this.loading = false;
            });
      }
  },
}

</script>
